module.exports = __webpack_public_path__ + "static/media/dt-cover.9fc2cc70.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/rbcx/dt-cover.png
// module id = 44
// module chunks = 0